import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";

export class BPMInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  saveValue = value => {
    var valueToSave = value;
    this.props.updateValue(this.props.field, valueToSave);
  };

  render() {
    return (
      <React.Fragment>
        <div className="ui-g-3">
          <label className="input-label">{this.props.placeholder}</label>
        </div>

        <div className="ui-g-9">
          <pr.InputText
            className={this.props.value ? "" : "ui-state-error"}
            required={true}
            value={this.props.value || ""}
            onChange={e => this.saveValue(e.target.value)}
            disabled={this.props.disabled}
          />
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/BPMInput.js